<template>
  <div class="uk-flex uk-flex-column border-box h-100" style="width:340px">
    <div class="border" style="height: calc(100% - 390px)">
      <TransportRecordSearch
        @onSelect="onSelect"
        :carrier-id="$route.query.carrierId"
      ></TransportRecordSearch>
    </div>
    <!--    地图-->
    <div class="bd-l bd-r  pd-10 uk-flex-1 border-box" style="overflow-y: auto">
      <div class="uk-flex uk-flex-middle">
        <MapTraceFilter
          :filter-option-list="filterOptionList"
          @onFilter="onFilter"
        ></MapTraceFilter>
      </div>
      <div>
        <TraceMap
          style="height: 300px"
          class="mt-5 mb-5"
          map-id="transMap"
          :tracableInfo="mapInfo"
          ref="map"
        ></TraceMap>
      </div>
    </div>
    <el-button
      type="primary"
      class="w-100"
      @click="viewDetail"
      :disabled="!pointInfo"
      >{{ pointInfo ? $t('查看详细') : $t('请选择轨迹点') }}
    </el-button>
    <TraceDetail ref="traceDetail"></TraceDetail>
  </div>
</template>

<script>
import TransportRecordSearch from '@/pages/business/win/TransportHistory/components/TransportRecordSearch.vue'
import MapTraceFilter from '@/pages/dataBoard/mapMonitor/components/ArchDetail/trace/components/MapTraceFilter.vue'
import { traceFilterOptions } from '@/api/modules/home'
import TraceMap from '@/pages/dataBoard/mapMonitor/components/ArchDetail/TraceMap.vue'
import { getTransHistory } from '@/api/modules/transport'
import { CONST_DEFAULT_LAT, CONST_DEFAULT_LNG } from '@/common/constant'
import TraceDetail from '@/pages/business/win/TransportHistory/components/HistoryMap/TraceDetail.vue'
import bus from '@/utils/bus'

export default {
  components: {
    TraceDetail,
    TraceMap,
    MapTraceFilter,
    TransportRecordSearch
  },
  computed: {
    mapInfo () {
      return {
        carrier: {
          id: this.$route.query.carrierId,
          lng: CONST_DEFAULT_LNG,
          lat: CONST_DEFAULT_LAT
        }
      }
    }
  },
  data () {
    return {
      form: {
        startTime: null,
        endTime: null
      },
      trace: [],
      filterOptionList: [],
      // 地图上选中点的信息
      pointInfo: null
    }
  },
  methods: {
    initFilterOptions () {
      traceFilterOptions({
        code: 'trace_filter',
        type: 0
      }).then(res => {
        this.filterOptionList = res.result
      })
    },
    onSelect (data) {
      getTransHistory(data.id).then(({ result }) => {
        if (this.$refs.map && result.trace) {
          this.$refs.map.renderTransportTrace(result.trace)
          this.trace = result.trace
        }
      })
      this.$emit('onSelect', data)
    },
    onFilter ({ option, speed }) {
      if (this.$refs.map) {
        this.$refs.map.filterTracePoint(this.trace, option, speed)
        this.$refs.map.renderTransportTrace(this.trace)
      }
    },
    viewDetail () {
      if (this.$refs.traceDetail) {
        const { id, time, speed } = this.pointInfo
        this.$refs.traceDetail.open(
          {
            id,
            time
          },
          {
            speed,
            time
          }
        )
      }
    }
  },
  mounted () {
    this.initFilterOptions()
    bus.$on('massClick', info => {
      this.pointInfo = info
    })
  }
}
</script>

<style lang="scss"></style>
